import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { Routes } from '@/router';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgCelebrateRewardsModal',
})
export default class CmgCelebrateRewardsModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardsCelebration.visible;
  }

  get bannerImageUrl(): string {
    return this.$appStore.state.cms.images.backgrounds.rewardCelebrationBanner.default;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth < ui.breakpoints.tablet;
  }

  get rewardMsg(): string {
    const args = this.$appStore.state.ui.modals.rewardsCelebration.args;
    return args
      ? !this.isUKCountry
        ? `${args.newRewardCount} REWARD${args.newRewardCount > 1 ? 'S' : ''}` 
        : `YOU HAVE ${args.newRewardCount > 1 ? `${args.newRewardCount} OFFERS!` : 'AN OFFER!'}`
      : '';
  }

  get pepperUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionReward.default;
  }

  get isUKCountry(): boolean {
    return this.$appStore.state.ui.countryProfile.countryCode === CountryCode.GB;
  }

  get ctaButtonText(): string {
    const args = this.$appStore.state.ui.modals.rewardsCelebration.args;
    return !this.isUKCountry ? 'My Rewards' : `SEE OFFER${args!.newRewardCount > 1 ? 'S' : ''}`;
  }

  get isRewardsOnline(): boolean{
    const flags = this.$appStore.state.featureFlags;
    if (flags.orderingStatus){
      return flags.orderingStatus.isRewardsOnline;
    }
    return true;
  }

  onClose() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsNotification,
      action: AnalyticsEventAction.RewardsNotificationCloseClick,
      label: AnalyticsEventLabel.RewardsNotificationCloseClick,
    });

    this.$services.ui.setModalVisibility('rewardsCelebration', false);
    const focusNearby = document.getElementsByClassName('customer-greeting')[0] as HTMLElement;
    if (focusNearby) {
      focusNearby.focus();
    }
  }

  navigateToRewards() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsNotification,
      action: AnalyticsEventAction.RewardsNotificationMyRewardsClick,
      label: AnalyticsEventLabel.RewardsNotificationMyRewardsClick,
    });
    
    const destinationRoute = !this.isUKCountry ? Routes.Rewards : Routes.Offers;
    this.$router.push({ name: destinationRoute });
    this.onClose();
  }
}
